/*
  THAANI — Sortierung der Kollektion nach Schaerfegrad.

  Shopify kann nicht nach Metafeldern sortieren, darum uebernimmt das hier der
  Browser: die Kacheln tragen data-schaerfe, das Skript ordnet sie um.

  Ohne JS passiert nichts — dann steht die normale Reihenfolge da, und die
  Optionen fuehren einfach zur unsortierten Seite. Deshalb bietet
  snippets/thaani-sortier-optionen.liquid sie auch nur an, wenn das ganze
  Sortiment auf einer Seite liegt.

  Dawn tauscht beim Filtern den Inhalt von #ProductGridContainer komplett aus.
  Ein Observer auf genau diesem Element (ohne subtree!) faengt das ab. Ohne
  das "ohne subtree" wuerde das eigene Umsortieren den Observer erneut
  ausloesen — Endlosschleife.
*/

(() => {
  const RICHTUNGEN = {
    'thaani-schaerfe-asc': 1,
    'thaani-schaerfe-desc': -1,
  };

  function gewaehlt() {
    const wert = new URLSearchParams(window.location.search).get('sort_by');
    return RICHTUNGEN[wert] ? { wert, faktor: RICHTUNGEN[wert] } : null;
  }

  /* Dawn setzt selected serverseitig — unsere Werte kennt Shopify nicht. */
  function auswahlNachziehen(wahl) {
    if (!wahl) return;
    document.querySelectorAll('select[name="sort_by"]').forEach((select) => {
      const passt = Array.from(select.options).some((o) => o.value === wahl.wert);
      if (passt && select.value !== wahl.wert) select.value = wahl.wert;
    });
  }

  function sortiere() {
    const wahl = gewaehlt();
    auswahlNachziehen(wahl);
    if (!wahl) return;

    const raster = document.getElementById('product-grid');
    if (!raster) return;

    const kacheln = Array.from(raster.children);
    if (kacheln.length < 2) return;

    kacheln
      .map((el, index) => {
        const roh = el.dataset.schaerfe;
        const grad = roh === undefined || roh === '' ? null : Number(roh);
        return { el, index, grad: Number.isFinite(grad) ? grad : null };
      })
      .sort((a, b) => {
        // Ohne Schaerfeangabe immer ans Ende, in beide Richtungen
        if (a.grad === null && b.grad === null) return a.index - b.index;
        if (a.grad === null) return 1;
        if (b.grad === null) return -1;
        return (a.grad - b.grad) * wahl.faktor || a.index - b.index;
      })
      .forEach(({ el }, position) => {
        // Die Reveal-Kaskade soll der neuen Reihenfolge folgen
        if (el.hasAttribute('data-cascade')) {
          el.style.setProperty('--animation-order', position + 1);
        }
        raster.appendChild(el);
      });
  }

  /*
    Dawn ersetzt beim Filtern zwei Bereiche: das Raster und die Filterleiste
    mit dem Sortier-Feld. Beide beobachten, sonst steht nach dem Filtern zwar
    die richtige Reihenfolge da, im Dropdown aber wieder "Empfohlen".
  */
  function beobachten() {
    ['ProductGridContainer', 'main-collection-filters'].forEach((id) => {
      const behaelter = document.getElementById(id);
      if (!behaelter) return;
      new MutationObserver(sortiere).observe(behaelter, { childList: true });
    });
  }

  function start() {
    sortiere();
    beobachten();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // Zurueck-Taste: Dawn rendert das Raster neu, der Parameter kann sich aendern
  window.addEventListener('popstate', () => window.setTimeout(sortiere, 0));
})();
